module.exports = __webpack_public_path__ + "media/cp4.fccdaf16.mp4";